import JSEncrypt from "jsencrypt";
import { AuthKeys, Session } from "./common";
import { JsonHelper } from "@maven-helper/helpers/Json.helper";
import { v4 as uuidV4 } from "uuid";

export const generateAuthKeys = (): AuthKeys => {
  const encrypt = new JSEncrypt({ default_key_size: "512" });
  const rsaKeyPair = encrypt.getKey();

  const privateKey = rsaKeyPair.getPrivateKey();
  const publicKey = rsaKeyPair.getPublicKey();
  const uuid = uuidV4();

  return { uuid, privateKey, publicKey };
};

export const decryptAuthKeys = (encryptedSession: string, privateKey: string) => {
  const decrypt = new JSEncrypt();

  decrypt.setPrivateKey(privateKey);

  const decrypted = decodeURIComponent(encryptedSession)
    .split(",")
    .reduce((acc, value) => acc + decrypt.decrypt(value), "");

  const session = JsonHelper.tryParse<Session>(decrypted);

  if (!session?.token || !session?.expiryAt) {
    throw new SessionDecryptionError(session);
  }

  return session;
};

export class SessionDecryptionError extends Error {
  constructor(decryptedValue: unknown) {
    super();
    this.name = "SessionDecryptionError";
    this.message = `Failed to decrypt session. Decrypted value: ${this.stringifyDecryptedValue(decryptedValue)}`;
  }

  private stringifyDecryptedValue(decryptedValue: unknown): string {
    if (typeof decryptedValue === "object") {
      return JSON.stringify(decryptedValue, (key, value) => (typeof value === "bigint" ? value.toString() : value));
    }

    return String(decryptedValue);
  }
}
